import constants from "../constants";

function bookmarkLists(state = {
  lists: null,
  bookmarks: null,
}, action) {
  switch (action.type) {
    case constants.FETCH_BOOKMARK_LISTS_DONE: {
      const bookmarks = {};
      const lists = [...action.data.lists].reduce((memo, list) => {
        memo[list.id] = list;

        list.entries.reduce((m, entry) => {
          m[entry.id] = entry;
          return m;
        }, bookmarks);

        return memo;
      }, {});

      return {
        lists,
        bookmarks,
      };
    }
    case constants.CREATE_BOOKMARK: {
      const bookmark = state.bookmarks[action.data.id];

      if (bookmark) {
        bookmark.checked = action.data.checked;
      }

      return {
        ...state,
      };
    }
    case constants.CREATE_BOOKMARK_DONE: {
      return {
        bookmarks: {
          [action.data.id]: {
            ...action.data,
          },
          ...state.bookmarks,
        },
        lists: { ...state.lists },
      };
    }
    default: {
      return state;
    }
  }
}

export default bookmarkLists;



// WEBPACK FOOTER //
// ./assets/pois/reducers/bookmarkLists.js